{
	"after": "After",
	"ariaEditorViewport": "Editor Viewport",
	"badgeError": "Error",
	"badgeHidden": "Hidden",
	"badgeLocked": "Locked",
	"badgeProcessed": "Processed",
	"badgeProcessing": "Processing",
	"badgeReference": "Reference",
	"badgeSuggested": "Suggested",
	"badgeUnsupported": "Unsupported",
	"notSupported": "Sorry, your browser or device is not supported.",
	"original": "Original",
	"photoStatus": "Photo Status: {{label}}"
}
